import { Navigation } from "../Navigation";

import "./Header.css";

export const Header = () => {
  return (
    <header className="navbar">
      <Navigation />
    </header>
  );
};
